import React, {FC, PropsWithChildren} from 'react';
import classNames from 'classnames';
import LaptopSizeWrapper from 'components/ContentPagesComponents/LaptopSizeWrapper';

import * as styles from './styles.module.scss';

export interface IImagePanelsProps {
	title: string;
}

const ImagePanels: FC<PropsWithChildren<IImagePanelsProps>> = ({title, children}) => {
	return (
		<LaptopSizeWrapper>
			<div className={classNames(styles.imagePanels, 'd-flex flex-column')}>
				<h4 className={styles.title}>{title}</h4>
				<div className={classNames(styles.panels, 'd-flex flex-row justify-content-center flex-wrap')}>
					{children}
				</div>
			</div>
		</LaptopSizeWrapper>
	);
};

export default ImagePanels;
